module.exports = __webpack_public_path__ + "static/media/icon_benefit_mission.acef0712.svg";